import { CCAssignmentCandidate } from '@/api/apis/resources';
import { CCShiftCell } from './CCShiftCell';
import { displayPhoneNumber } from '@/utils/helpers';
import { AvatarWithName, MandatoryRoleAssignButton } from '../components';

export type CoordinatorRowData = CCAssignmentCandidate & {
  isSelected: boolean;
  isPrimary: boolean;
  isLast: boolean;
};

export const renderCoordinatorTableCell =
  (onAssign: (coordinator: CoordinatorRowData) => void) => (item: CoordinatorRowData, columnKey: string) => {
    const {
      employeeProfilePhoto,
      employeeFullName,
      isPrimary,
      isSelected,
      phone,
      isLast,
      lastActiveShift,
      nextOnCallShift,
    } = item;

    switch (columnKey) {
      case 'name':
        return <AvatarWithName name={employeeFullName!} photo={employeeProfilePhoto!} isPrimary={isPrimary} />;
      case 'phone':
        return <span>{phone ? displayPhoneNumber(phone) : '-'}</span>;
      case 'currentShift':
        return <CCShiftCell ccShift={lastActiveShift} position="end" />;
      case 'nextShift':
        return <CCShiftCell ccShift={nextOnCallShift} position="start" />;
      case 'action':
        return (
          <MandatoryRoleAssignButton
            isSelected={isSelected}
            isLast={isLast}
            name={employeeFullName!}
            roleName="Clinical Coordinator"
            onAssign={() => onAssign(item)}
          />
        );
      default:
        return null;
    }
  };
